export default __webpack_public_path__ + "static/media/cp_geo_bv.a0dbef9d.svg";